<template>
    <div class="writingsblock-container">
      <div class="main-box page-content-box">
        <BlockTitle
          title="王选文萃"
          channelAlias="wencui"></BlockTitle>

        <Quotation  
          class="quotation"        
         :content="quotationContent"></Quotation>
        <template v-if="tabMode == true">          
          <div class="block-list">
            <swiper class="writing-swiper" ref="swiper" :options="swiperOption">
              <swiper-slide
                class="writing-slide text-select-disable"
                v-for="item in blockList"
                :key="item.id">
                <span class="slide-title"
                  @click="handleClickTab(item)"
                  :class="{'is-tab-active': activeTab == item.alias}">{{item.name}}</span>
              </swiper-slide>            
            </swiper>
            <WritingsItem v-for="item in blockList"
              :key="'swp'+item.id"
              :blockItem="item"
              class = "block-item"
              :hasFooter="true"
              :style="{display: activeTab == item.alias ? '' : 'none'}"
              >
            </WritingsItem>
          </div>
        </template>
        <template v-else>
          <div class="block-list">
              <WritingsItem v-for="item in blockList.slice(0, 3)"
                :key="item.id"
                :blockItem="item"
                :hasFooter="false"
                class = "block-item"
                >
              </WritingsItem>
          </div>
          <div class="block-list">
            <WritingsItem v-for="item in blockList.slice(3)"
              :key="item.id"
              :blockItem="item"
              :hasFooter="false"
              class = "block-item"
              >
            </WritingsItem>
          </div>
        </template>
      </div>
    </div>
</template>
<script>
  import BlockTitle from "@/components/blocks/blocktitle";
  import Quotation from "@/components/blocks/quotation";
  import WritingsItem from "./writingsitem.vue";
  import * as channelConfig from "@/config/channels";
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

    export default{
      components: {BlockTitle, Quotation, WritingsItem, swiper, swiperSlide},
        props:{},
        data(){
            return {
              quotationContent: "“学术上的远大抱负”与“占领市场”是可以相互促进的。高科技产业实现“顶天立地”模式。“顶天”就是不断追求技术上的新突破；“立地”就是把技术商品化，并大量推广、应用。“顶天”是为了更好地“立地”，从市场获取用户新的需求，进一步推动技术的创新和突破。",

              blockList:[
                {
                  id: 1,
                  name: '回忆激光照排',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_JIGUANGZHAOPAI,
                },
                {
                  id: 2,
                  name: '论科研与创新',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_KEYANCHUANGXIN,
                },
                {
                  id: 3,
                  name: '论技术与市场',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_JISHUSHICHANG,
                },
                {
                  id: 4,
                  name: '论高科技企业',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_KEJIQIYE,
                },
                {
                  id: 5,
                  name: '论教育与人才',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_JIAOYURENCAI,
                },
                {
                  id: 6,
                  name: '论时事与人文',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_SHISHIRENWEN,
                },
              ],
              // 展示模式
              tabMode: false,
              swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 10,
                direction: 'horizontal',
                          
              },
              activeTab: channelConfig.blockAlias.BLOCK_ALIAS_JIGUANGZHAOPAI,
            }
        },
        methods:{
          onResize(){
            //let screenW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            let screenW = document.documentElement.clientWidth;
            if(screenW <= 750){
              this.tabMode = true;
            }else{
              this.tabMode = false;
            }
          },

          handleClickTab(item){
            this.activeTab = item.alias;
          }
        },
        created(){
          window.addEventListener('resize', this.onResize);
        },
        destroyed(){
          window.removeEventListener('resize', this.onResize);
        },
        
        mounted(){
          this.$nextTick(()=>{
              this.onResize();
          });
        },
    };
</script>
<style scoped>
.writingsblock-container{
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  padding: 60px 0px 60px 0px;
  background: #F3F6F9;
  background-image: url('../../../assets/img/home-bg-wencui.png');
  background-repeat: no-repeat;
  background-position:top right;
  background-size: 500px;
}
 .main-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    /*gap: 40px;*/

 }
 .quotation{
  margin-top: 40px;
 }

 .block-list{
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  /*gap: 30px;*/
  margin-left: -15px;
  margin-right: -15px;
  margin-top: 40px;
 }
 .block-item{
  width: 30%;
  box-sizing: border-box;
  margin-left: 15px;
  margin-right: 15px;
 }

 @media screen and (max-width: 1000px){  
  .writingsblock-container{
    padding: 24px 0;
    background-size: 30%;
  }
  /*
  .main-box{
    gap: 20px;
  }
  */
  .quotation{
    margin-top: 20px;
  }
  .block-list{
    /*gap: 10px;*/
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 20px;
  }
  .block-item{    
    margin-left: 5px;
    margin-right: 5px;
  }

 }
 @media screen and (max-width: 750px){  
  .block-list{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    /*gap: 10px;*/
    margin-left: -5px;
    margin-right: -5px;
    padding: 10px 20px;
    background: #fff;
  } 
  
  .block-item{
    width: 100%; 
    margin-left: 5px;
    margin-right: 5px;
  }
  .writing-swiper{
    width: 100%;
    padding: 0px;
    border-bottom: 1px solid #D8DCE2;
    padding: 8px 0px;
  }
  .writing-slide{
    width: fit-content;
    cursor: pointer;
  }
  .slide-title{
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0em;
    color: #3B3F47;
    padding: 10px 0px;
    cursor: pointer;
  }
  .is-tab-active{
    color: #014289;
    border-bottom: 2px solid #014289;
  }

 }

</style>



// WEBPACK FOOTER //
// src/components/blocks/writingsblock/index.vue